import { Controller } from "@hotwired/stimulus"

// Cierra automáticamente los flashes/notices (portado de documentaweb)
export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } }

  connect() {
    this.timer = setTimeout(() => {
      this.element.style.transition = "opacity 0.4s ease"
      this.element.style.opacity = "0"
      setTimeout(() => this.element.remove(), 400)
    }, this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
